import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Dialog, Button, IconButton } from 'react-toolbox';
import { connect } from 'react-redux';
import TextArea from 'components/TextArea';
import S from 'modal.scss';
import styles from 'styles/input.scss';
import { clearValidation, copyPhase } from 'actionCreators/phase';
import { navigate } from 'actionCreators';
import { urls } from 'helpers/url';
import PhaseType from 'types/phase';
import { getPhaseErrors } from '../../../../../../reducers';
import cx from 'classnames';
import StyledSelect from 'components/StyledSelect';
import { WORKORDER_TYPE } from 'config/constants';
import { woSourceOptions } from '../../../../../../utils';

const largeInput = cx(styles.inputs, styles.largeInput);
const titleStyle = cx(styles.bottomTitle, styles.childTitle);

class WorkorderModal extends Resetter(Validator(React.Component)) {
  static DEFAULT_STATE = { note: '', errors: {}, wo_source: '', wo_type: '' }
  static VALIDATIONS = { note: true, wo_source: true, wo_type: true }

  handleSubmit = () => {
    if (!this.validate()) { return; }
    const { phase } = this.props;
    const { note, wo_source, wo_type } = this.state;
    this.props.copyPhase(phase.id, { note, wo_source, wo_type })
      .then(() => this.handleClose())
      .then(() => this.props.navigate(urls.phaseLaborProductAccounting(this.props.phase)))
      .catch(() => { });
  }

  handleClose() {
    super.handleClose();
    this.props.clearValidation();
  }

  handleNoteChange = e => this.setState({ note: e.target.value });

  handleWorkorderInfo = (key, value) => this.setState({ [key]: value });

  render = () => {
    const { note, errors } = this.state;
    const { phase, active, errors: serverErrors } = this.props;
    return (<Dialog
      active={active} className={S.modal} type="fullscreen"
      onEscKeyDown={this.handleClose} onOverlayClick={this.handleClose}
    >
      <div className={styles.errored}>
        {Object.keys(serverErrors).length > 0 &&
          <span className={styles.error}>This action could not be completed.</span>}
      </div>
      <IconButton
        icon="close"
        className={S.close}
        onClick={this.handleClose}
        tabIndex={-1}
      />
      <h5 className={S.title}>Create Workorder</h5>
      <h5 className={titleStyle}>Workorder Source / Type</h5>
      <br />
      <StyledSelect
        className={largeInput}
        label="Workorder Source"
        onChange={selection => this.handleWorkorderInfo('wo_source', selection)}
        options={woSourceOptions(phase)}
        value={this.state.wo_source}
        placeholder={'Select Workorder Source'}
        required
        autoFocus
        error={errors.wo_source}
      />
      <StyledSelect
        className={largeInput}
        label="Workorder Type"
        onChange={selection => this.handleWorkorderInfo('wo_type', selection)}
        options={WORKORDER_TYPE.map(wt => ({ value: wt, label: wt }))}
        value={this.state.wo_type}
        placeholder={'Select Workorder Type'}
        required
        error={errors.wo_type}
      />
      <TextArea
        label="Reason *"
        required
        value={note}
        errors={errors.note}
        onChange={this.handleNoteChange}
      />
      <Button label="Create" flat inverse ripple className={S.submit} onClick={this.handleSubmit} />
    </Dialog>);
  }
}

WorkorderModal.propTypes = {
  active: PropTypes.bool.isRequired,
  copyPhase: PropTypes.func,
  navigate: PropTypes.func.isRequired,
  clearValidation: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  errors: PropTypes.shape({
    note: PropTypes.arrayOf(PropTypes.string),
    due_at: PropTypes.arrayOf(PropTypes.string),
  }),
};

WorkorderModal.defaultProps = { active: false };

export default connect(state => ({ errors: getPhaseErrors(state) }),
  { clearValidation, copyPhase, navigate })(WorkorderModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/workorderModal.jsx